import {Injectable} from '@angular/core';
import {MapContextService} from '../map-context.service';
// tslint:disable
import {BaseLayerDeck} from '../layers/baseLayerDeck';

// tslint:enable

@Injectable()
export class LayerService {

    layers = {};
    mapContext: MapContextService;

    constructor(mapContext: MapContextService) {
        this.mapContext = mapContext;
    }

    addLayer(layer: any, visible = true, underLayerId = null, loadedCallback: (layer) => void = null) {
        if (!layer.id) {
            throw new Error('[layerService.addLayer] layer id must be defined. Received "${layer.id}" instead');
        }

        this.layers[layer.id] = layer;
        if (layer instanceof BaseLayerDeck) {
            layer.init(this.mapContext, visible, underLayerId, loadedCallback);
        }
        return layer;
    }

    hasLayer(id) {
        return !!this.layers[id];
    }

    getLayer(id) {
        return this.layers[id];
    }

    hideLayer(id) {
        if (this.hasLayer(id)) {
            if (this.layers[id] instanceof BaseLayerDeck) {
                this.layers[id].hide();
            } else {
                this.updateLayer(id, {visible: false});
            }
        }
    }

    removeLayer(id) {
        if (this.hasLayer(id)) {
            if (this.layers[id] instanceof BaseLayerDeck) {
                this.layers[id].destroy();
            }
            delete this.layers[id];
        }
    }

    showLayer(id) {
        if (this.hasLayer(id)) {
            if (this.layers[id] instanceof BaseLayerDeck) {
                this.layers[id].show();
            } else {
                this.updateLayer(id, {visible: true});
            }
        }
    }

    updateLayer(id, data, sublayer = null) {
        if (!this.hasLayer(id)) {
            return;
        }
        if (this.layers[id] instanceof BaseLayerDeck) {
            if (sublayer) {
                this.layers[id].update(sublayer, data);
            } else {
                this.layers[id].updateAll(data);
            }
        } else {
            this.layers[id] = {
                ...this.layers[id],
                ...data
            };
        }
    }

    getViewportFeatures(layer: string | string[] = null) {
        if (!this.mapContext.deckInstance) {
            return [];
        }
        const layers = Object.keys(this.layers).filter(
            l => !layer || Array.isArray(layer) && layer.includes(l) || layer === l
        );
        if (!layers) {
            return [];
        }
        return layers.map(l => ({
            layer: this.layers[l],
            features: this.layers[l].getViewportFeatures()
        }));
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/layer.service.ts